import React from "react";
import { Box, Typography, Container, Grid, Divider } from "@mui/material";

const PRIMARY = "#CC0000";

const members = [
  {
    name: "ハルヨシ",
    nameJp: "高田 治吉",
    role: "CEO",
    dept: "SNS戦略・クリエイティブ全般",
    bio: "SNS採用事業、SNS動画制作事業の立ち上げ・推進経験を持ち、企業の魅力を最大限に引き出すコンテンツ戦略に精通。",
  },
  {
    name: "タカノリ",
    nameJp: "高田 隆徳",
    role: "COO",
    dept: "toC事業運営",
    bio: "ITとSNS、どちらか一方に偏らない視点で、お客様の課題を統合的に解決。各事業のプロフェッショナルを結びつけ、TriArrowsのサービス品質とチーム全体のパフォーマンスを最大化します。",
  },
  {
    name: "トモミ",
    nameJp: "高田 知己",
    role: "CTO",
    dept: "toB事業運営・システム【開発・保守・運用】部門",
    bio: "大手SIerで培った高品質なシステム運用ノウハウを、貴社のサービスへ落とし込みます。特に、システム稼働後のコスト最適化と安定稼働を約束し、IT事業の継続的な成長をリードします。",
  },
];

const companyProfile = [
  { label: "名称", value: "TriArrows合同会社" },
  { label: "所在地", value: "〒150-0011　石川県金沢市田上本町4-40" },
  { label: "設立", value: "2024年4月" },
  { label: "代表者", value: "代表取締役　高田 治吉" },
  { label: "資本金", value: "30万円" },
  { label: "メンバー", value: "24名（取締役3名　正社員1名　業務委託20名）" },
  { label: "事業内容", value: "システム開発・保守・運用\nSNS運用" },
];

const CompanyPage = () => {
  return (
    <Box>
      {/* Page Hero */}
      <Box
        sx={{
          bgcolor: PRIMARY,
          color: "white",
          py: { xs: 8, md: 12 },
        }}
      >
        <Container maxWidth="lg">
          <Typography
            sx={{ fontSize: "0.85rem", fontWeight: 600, letterSpacing: 3, mb: 2, opacity: 0.85 }}
          >
            Company
          </Typography>
          <Typography
            variant="h2"
            sx={{ fontWeight: 900, fontSize: { xs: "2rem", md: "3rem" } }}
          >
            会社について
          </Typography>
        </Container>
      </Box>

      {/* Mission Section */}
      <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: "#f8f8f8" }}>
        <Container maxWidth="lg">
          <Grid container spacing={8} alignItems="center">
            <Grid item xs={12} md={5}>
              <Typography
                sx={{
                  fontSize: "0.85rem",
                  fontWeight: 600,
                  letterSpacing: 3,
                  color: PRIMARY,
                  mb: 2,
                }}
              >
                Mission
              </Typography>
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 900,
                  fontSize: { xs: "1.6rem", md: "2.2rem" },
                  lineHeight: 1.4,
                  mb: 4,
                }}
              >
                ITの力で社会の課題を解決し
                <br />
                未来を創造する
              </Typography>
              <Box sx={{ width: 40, height: 4, bgcolor: PRIMARY }} />
            </Grid>
            <Grid item xs={12} md={7}>
              <Typography
                sx={{
                  fontSize: "0.95rem",
                  lineHeight: 2,
                  color: "#555",
                  fontStyle: "italic",
                  mb: 3,
                }}
              >
                静かに脈打つ、デジタルの鼓動。
                <br />
                それは、世界を編み上げる見えない糸。
                <br />
                複雑に絡まる、時代の「課題」を、論理（ロジック）の光で、紐解いていく。
                <br />
                コードに託すのは、ただの機能ではない。
                <br />
                人々の困りごとに寄り添う、確かな願い。
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Corporate Message */}
      <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: "#1a1a1a" }}>
        <Container maxWidth="lg">
          <Grid container spacing={8} alignItems="center">
            <Grid item xs={12} md={5}>
              <Typography
                sx={{
                  fontSize: "0.85rem",
                  fontWeight: 600,
                  letterSpacing: 3,
                  color: PRIMARY,
                  mb: 2,
                }}
              >
                Corporate Message
              </Typography>
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 900,
                  fontSize: { xs: "1.8rem", md: "2.5rem" },
                  color: "white",
                  lineHeight: 1.4,
                }}
              >
                繋ぎ、関わり、
                <br />
                成長する
              </Typography>
            </Grid>
            <Grid item xs={12} md={7}>
              <Typography sx={{ color: "rgba(255,255,255,0.75)", lineHeight: 2, mb: 3 }}>
                開発者の深い知見と熱意をもって、まだ顕在化していないシステムの潜在的な課題と価値を徹底的に「見つける」ことから全てが始まります。それは、お客様の未来への羅針盤となる最初のステップです。
              </Typography>
              <Typography sx={{ color: "rgba(255,255,255,0.75)", lineHeight: 2, mb: 3 }}>
                見つけた課題解決への道筋と、ビジネスの成長の可能性を、明確で説得力のある言葉でお客様に「伝える」。深く関わり、本質的な議論を重ねることで、信頼という名の強固なパートナーシップを築きます。
              </Typography>
              <Typography sx={{ color: "rgba(255,255,255,0.75)", lineHeight: 2 }}>
                そして、その提案を実行に移し、お客様のビジネスを確かな形で「進化させる」。私たちの貢献が、お客様の持続的な成長となり、やがて社会全体の発展へと繋がることを目指します。
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Members Section */}
      <Box sx={{ py: { xs: 8, md: 12 } }}>
        <Container maxWidth="lg">
          <Typography
            sx={{
              fontSize: "0.85rem",
              fontWeight: 600,
              letterSpacing: 3,
              color: PRIMARY,
              mb: 1,
            }}
          >
            Members
          </Typography>
          <Typography
            variant="h3"
            sx={{ fontWeight: 900, mb: 8, fontSize: { xs: "1.8rem", md: "2.5rem" } }}
          >
            メンバー
          </Typography>

          <Grid container spacing={4}>
            {members.map((member, i) => (
              <Grid item xs={12} md={4} key={i}>
                <Box
                  sx={{
                    p: 4,
                    border: "1px solid #e0e0e0",
                    height: "100%",
                    position: "relative",
                    "&:hover": { borderColor: PRIMARY },
                    transition: "border-color 0.2s",
                  }}
                >
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: PRIMARY,
                      color: "white",
                      width: 56,
                      height: 56,
                      borderRadius: "50%",
                      fontWeight: 900,
                      fontSize: "1.2rem",
                      mb: 3,
                    }}
                  >
                    {member.name[0]}
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "baseline", gap: 1.5, mb: 0.5 }}>
                    <Typography variant="h5" sx={{ fontWeight: 900 }}>
                      {member.name}
                    </Typography>
                    <Typography
                      sx={{
                        bgcolor: PRIMARY,
                        color: "white",
                        px: 1,
                        py: 0.2,
                        fontSize: "0.7rem",
                        fontWeight: 700,
                      }}
                    >
                      {member.role}
                    </Typography>
                  </Box>
                  <Typography sx={{ fontSize: "0.85rem", color: "#888", mb: 2 }}>
                    {member.nameJp}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.75rem",
                      color: PRIMARY,
                      fontWeight: 700,
                      mb: 2,
                      letterSpacing: 1,
                    }}
                  >
                    {member.dept}
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                  <Typography sx={{ fontSize: "0.9rem", lineHeight: 1.8, color: "#555" }}>
                    {member.bio}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Company Profile Section */}
      <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: "#f8f8f8" }}>
        <Container maxWidth="lg">
          <Typography
            sx={{
              fontSize: "0.85rem",
              fontWeight: 600,
              letterSpacing: 3,
              color: PRIMARY,
              mb: 1,
            }}
          >
            Profile
          </Typography>
          <Typography
            variant="h3"
            sx={{ fontWeight: 900, mb: 6, fontSize: { xs: "1.8rem", md: "2.5rem" } }}
          >
            会社概要
          </Typography>

          <Box sx={{ bgcolor: "white", border: "1px solid #e0e0e0" }}>
            {companyProfile.map(({ label, value }, i) => (
              <Box
                key={label}
                sx={{
                  display: "flex",
                  borderBottom: i < companyProfile.length - 1 ? "1px solid #e0e0e0" : "none",
                }}
              >
                <Box
                  sx={{
                    flexBasis: { xs: "120px", md: "200px" },
                    flexShrink: 0,
                    p: 3,
                    bgcolor: "#fafafa",
                    borderRight: "1px solid #e0e0e0",
                  }}
                >
                  <Typography sx={{ fontWeight: 700, fontSize: "0.9rem", color: "#333" }}>
                    {label}
                  </Typography>
                </Box>
                <Box sx={{ p: 3, flexGrow: 1 }}>
                  <Typography sx={{ whiteSpace: "pre-line", fontSize: "0.95rem", color: "#444" }}>
                    {value}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default CompanyPage;
